<template>
  <div class="whiteboard-control">
    <div class="whiteboard-menu-group">
      <div
        :class="['whiteboard-menu', { 'active': tool === 'pencil' }]"
        @click="setTool('pencil')"
        v-b-tooltip.hover.right
        :title="isMobile ? null : $t('pages.room.whiteboard.tooltip.pen')"
      >
        <v-fa icon="pen" size="lg" />
      </div>
      <div
        :class="['whiteboard-menu', { 'active': tool === 'eraser' }]"
        @click="setTool('eraser')"
        v-b-tooltip.hover.right
        :title="isMobile ? null : $t('pages.room.whiteboard.tooltip.eraser')"
      >
        <v-fa icon="eraser" size="lg" />
      </div>
    </div>
    <div class="whiteboard-menu-group">
      <div class="whiteboard-stroke-color"
        @click="colorPickerModal=true"
        :style="`background-color: ${color};`"
        v-b-tooltip.hover.right
        :title="isMobile ? null : $t('pages.room.whiteboard.tooltip.strokeColor')"
      />
      <div
        class="whiteboard-stroke-size"
        @click="toggleSize"
        v-b-tooltip.hover.right
        :title="isMobile ? null : $t('pages.room.whiteboard.tooltip.strokeSize')"
      >
        <span :class="`circle ${size}`" :style="`background-color: ${color};`"/>
      </div>
    </div>
    <div class="whiteboard-menu-group">
      <div
        v-if="isSupportedDisplayMedia && (projector.isStreamOwner || !projector.stream)"
        :class="['whiteboard-menu', { 'active': projector.isStreamOwner }]"
        @click="$emit('onClickProjector')"
        v-b-tooltip.hover.right
        :title="isMobile ? null : $t('pages.room.whiteboard.tooltip.projector')"
      >
        <v-fa icon="desktop" size="lg" />
      </div>
      <div
        class="whiteboard-menu active"
        @click="$emit('onClickImagePaste')"
        v-b-tooltip.hover.right
        :title="isMobile ? null : $t('pages.room.whiteboard.tooltip.imagePaste')"
      >
        <v-fa icon="image" size="lg" />
      </div>
      <div
        class="whiteboard-menu active"
        @click="$emit('onClickSnapshot')"
        v-b-tooltip.hover.right
        :title="isMobile ? null : $t('pages.room.whiteboard.tooltip.snapshot')"
      >
        <v-fa icon="camera" size="lg" />
      </div>
      <div
        class="whiteboard-menu active"
        @click="$emit('onClickClearWhiteboard')"
        v-b-tooltip.hover.right
        :title="isMobile ? null : $t('pages.room.whiteboard.tooltip.clear')"
      >
        <v-fa icon="trash" size="lg" />
      </div>
    </div>
    <whiteboard-color-picker-modal
      :modal="colorPickerModal"
      @toggleModal="(modal) => colorPickerModal = modal"
    />
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import WhiteboardColorPickerModal from '@/components/organisms/room/WhiteboardColorPickerModal'

export default {
  name: 'WhiteboardControl',
  components: {
    WhiteboardColorPickerModal
  },
  props: {
    isMobile: Boolean,
    isSupportedDisplayMedia: Boolean
  },
  data() {
    return {
      colorPickerModal: false
    }
  },
  computed: {
    ...mapGetters({
      tool: 'whiteboard/tool',
      color: 'whiteboard/color',
      size: 'whiteboard/size',
      projector: 'projector/projector'
    })
  },
  methods: {
    ...mapMutations({
      setTool: 'whiteboard/setTool',
      toggleSize: 'whiteboard/toggleSize'
    })
  }
}
</script>

<style scoped lang="scss">
@import "@/styles/mediaquery";
@import "@/styles/variables";

.whiteboard-control {
  background: linear-gradient(0deg, #00b0e5, #00b0e5),
    linear-gradient(
      180deg,
      rgba(255, 255, 255, 0.2) 0%,
      rgba(255, 255, 255, 0) 100%
    );
  padding: 10px;
  z-index: 2;
  box-shadow: -2px 4px 20px 0px rgba(16, 70, 86, 0.12);
  border-right: none;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 90%;
  border-radius: 8px 0 0 8px;

  @include mq(md) {
    flex-direction: column;
    width: auto;
  }

  .whiteboard-menu-group {
    display: flex;

    @include mq(md) {
      display: block;
    }
  }

  .whiteboard-menu {
    cursor: pointer;
    padding: 5px;
    margin-right: 5px;
    @include mq(md) {
      margin-right: 0;
      margin-bottom: 10px;
    }
    color: $text-translucent-color;

    &.active {
      color: $text-color;
    }
  }

  .whiteboard-stroke-color {
    width: 30px;
    margin-right: 10px;
    @include mq(md) {
      width: 100%;
      margin-bottom: 10px;
      margin-right: 0;
    }
    border-radius: 10%;

    &:before {
      content: "";
      display: block;
      padding-top: 100%;
    }
  }

  .whiteboard-stroke-size {
    width: 30px;
    @include mq(md) {
      width: 100%;
      margin-bottom: 10px;
    }
    border: 1px solid rgba(255, 255, 255, 0.6);
    border-radius: 10%;
    background: transparent;
    position: relative;
    box-shadow: -2px 4px 20px 0px rgba(16, 70, 86, 0.12);

    &:before {
      content: "";
      display: block;
      padding-top: 100%;
    }

    .circle {
      position: absolute;
      border-radius: 50%;

      &.sm {
        top: 35%;
        left: 35%;
        width: 30%;
        height: 30%;
      }

      &.md {
        top: 25%;
        left: 25%;
        width: 50%;
        height: 50%;
      }

      &.lg {
        top: 15%;
        left: 15%;
        width: 70%;
        height: 70%;
      }
    }
  }
}
</style>
